<template>
  <div class="page">
    <div class="page-title">Checkout</div>
    <div class="page-content">
      <h3 class="m-0">In Your Cart:</h3>
      <div
        v-for="type in $consts.purchaseableNodeTypes"
        :key="`type-count-${type}`"
      >
        <div v-if="getComputedMethodForType(type).length">
          {{ getComputedMethodForType(type).length }}
          {{ $consts.NODE_LABELS_FOR_PATH_TYPE[type] }}
        </div>
      </div>
      <router-link class="btn small-btn" to="/purchase">Edit Cart</router-link>
      <hr />

      <h2>Order Options</h2>
      <div class="mb-3">
        Use the selections below to let us know some more details about how you
        wish to receive your order.
      </div>

      <div
        v-for="option in checkoutOptions"
        :key="option.label"
        class="option-group"
      >
        <div v-if="option.type == 1">
          <input
            :id="option.label"
            type="checkbox"
            v-model="optionSelections[option.id]"
          />
          <label :for="option.label">&nbsp;{{ option.label }}</label>
        </div>
        <div v-if="option.type == 2">
          <label>{{ option.label }}</label>
          <div>
            <textarea v-model="optionSelections[option.id]" />
          </div>
        </div>
      </div>

      <div class="text-right">
        <loading-panel :loading="isLoading" message="Preparing your order">
          <button class="btn" @click="onNext">Next: Payment Details</button>
        </loading-panel>
      </div>

      <error-panel :errors="[error]"></error-panel>

      <hr />
    </div>
  </div>
</template>

<script>
export default {
  name: "checkout",
  components: {},
  data() {
    let checkoutOptions = [];
    let fromStore = this.$store.state.purchase.checkoutOptions;
    if (fromStore && fromStore.length) {
      checkoutOptions = fromStore;
    } else {
      checkoutOptions = this.$storage.readObject("checkout-options");
    }

    let optionSelections = this.$storage.readObject("option-selections");
    if (!optionSelections) {
      optionSelections = {};

      checkoutOptions.forEach((option) => {
        if (option.type == 1) {
          optionSelections[option.id] = false;
        } else {
          optionSelections[option.id] = "";
        }
      });
    }

    console.log("selects: ", optionSelections);

    return {
      error: "",
      isLoading: false,
      errors: [],
      optionSelections,
    };
  },
  methods: {
    getComputedMethodForType(type) {
      return this[type];
    },
    async onNext() {
      this.$storage.writeObject("option-selections", this.optionSelections);

      // Create the order in PV database
      try {
        this.isLoading = true;
        const nodeIds = this.nodesInCart.map((node) => node.node.id);
        const response = await this.$web.createOrder(
          nodeIds,
          this.optionSelections,
          window.location.origin
        );

        if (!response.data.sessionId) {
          this.error = "Unable to create checkout session at this time";
          return;
        }

        const stripe = Stripe(process.env.VUE_APP_STRIPE_PK);
        await stripe.redirectToCheckout({
          sessionId: response.data.sessionId,
        });
      } catch (e) {
        console.log("Error: ", e);
        this.error = "An error occurred. Unable to place order at this time.";
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    nodesInCart() {
      var nodeJson = this.$storage.read("cart");
      var nodes = nodeJson ? JSON.parse(nodeJson) : [];
      return nodes;
    },
    checkoutOptions() {
      let fromStore = this.$store.state.purchase.checkoutOptions;
      if (fromStore && fromStore.length) return fromStore;
      let fromStorage = this.$storage.readObject("checkout-options");
      return fromStorage;
    },
    panels() {
      return this.nodesInCart.filter(
        (node) => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.panels
      );
    },
    mccs() {
      return this.nodesInCart.filter(
        (node) => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.mccs
      );
    },
    vfds() {
      return this.nodesInCart.filter(
        (node) => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.vfds
      );
    },
    breakers() {
      return this.nodesInCart.filter(
        (node) => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.breakers
      );
    },
    starters() {
      return this.nodesInCart.filter(
        (node) => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.starters
      );
    },
    softstarts() {
      return this.nodesInCart.filter(
        (node) => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.softstarts
      );
    },
    distribution_panelboards() {
      return this.nodesInCart.filter(
        (node) =>
          node.node.type ==
          this.$consts.NODE_TYPE_STR_TO_INT.distribution_panelboards
      );
    },
    switchboards() {
      return this.nodesInCart.filter(
        (node) =>
          node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.switchboards
      );
    },
    transformers() {
      return this.nodesInCart.filter(
        (node) =>
          node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.transformers
      );
    },
    disconnect_switches() {
      return this.nodesInCart.filter(
        (node) =>
          node.node.type ==
          this.$consts.NODE_TYPE_STR_TO_INT.disconnect_switches
      );
    },
    fuses() {
      return this.nodesInCart.filter(
        (node) => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.fuses
      );
    },
    auxnodes() {
      return this.nodesInCart.filter(
        (node) => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT.auxnodes
      );
    },
  },
  async mounted() {},
};
</script>

<style lang="scss" scoped>
.checkout {
  margin: auto;
  margin-top: 15px;
  max-width: 360px;

  @media screen and (min-width: 768px + 250px + 50px) {
    max-width: 768px;
  }
}

.option-group {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
